import { httpClient } from "@/infrastructure/http/client/httpClient";
import type { LiveMetricsSnapshot } from "@/domain/projection/importLive";
import type { PlanCatalogItem } from "@/domain/types/planCatalog";
import type { TenantGridDTO } from "@/domain/repositories/ITenantRepository";
import type { EcosystemUsageReportDTO, SaasMetricsDTO } from "@/domain/repositories/IReportRepository";

export async function fetchLiveMetricsSnapshot(): Promise<LiveMetricsSnapshot> {
  const [plans, tenants, usage, saas, adicionales, recurrentes] = await Promise.all([
    httpClient.get<PlanCatalogItem[]>("/plans").then((res) => res.data).catch(() => [] as PlanCatalogItem[]),
    httpClient.get<TenantGridDTO[]>("/tenants").then((res) => res.data).catch(() => [] as TenantGridDTO[]),
    httpClient.get<EcosystemUsageReportDTO>("/reports/ecosystem-usage").then((res) => res.data).catch(() => null),
    httpClient.get<SaasMetricsDTO>("/reports/saas-metrics").then((res) => res.data).catch(() => null),
    httpClient.get<LiveMetricsSnapshot["adicionales"]>("/admin/adicionales").then((res) => res.data).catch(() => []),
    httpClient.get<LiveMetricsSnapshot["recurrentes"]>("/balance/recurrentes").then((res) => res.data).catch(() => []),
  ]);

  return {
    plans: Array.isArray(plans) ? plans : [],
    tenants: Array.isArray(tenants) ? tenants : [],
    usage,
    saas,
    adicionales: Array.isArray(adicionales) ? adicionales : [],
    recurrentes: Array.isArray(recurrentes) ? recurrentes : [],
  };
}
